import React, { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import DescriptionIcon from "@material-ui/icons/Description";
import GroupIcon from "@material-ui/icons/Group";
import PolicyIcon from "@material-ui/icons/Policy";
import * as Glob from "src/Globale";
import { Trad } from "src/components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _InfoTabs, _BondForm } from "../components";

export interface IRouteParam {
    ID_Anag: string;
    ID_FideAffidamento: string;
    ID_Polizza: string;
}

export const _Bond: React.FC<Glob.IRouteGlobaleProps> = props => {
    const { ID_Anag, ID_FideAffidamento, ID_Polizza } = useParams<IRouteParam>();

    useEffect(() => {
        if (!Glob.AzioneAbilitata("PolizzaController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }

        props.SetMenu({ ...Glob.GetMenu(), Main: "Affidamento", ID_MenuMain: 24, VariabiliMenu: { ["{ID_FideAffidamento}"]: ID_FideAffidamento } });
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={PolicyIcon} Title="Polizza">
                    {Glob.AzioneAbilitata("PolizzaController", Glob.Scrittura) && (
                        <NavLink to={`/anagrafica/${ID_Anag}/FideAffidamento/${ID_FideAffidamento}/FidePolizza/0`}>
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <AddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                    {ID_Polizza && Number(ID_Polizza) > 0 && (
                        <a href={`/file/${ID_Polizza}`}>
                            <Tooltip title={Trad.Trad("Documenti")}>
                                <IconButton size="small" aria-label="document">
                                    <DescriptionIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                    <NavLink to={`/anagrafica/${ID_Anag}/fideaffidamento/${ID_FideAffidamento}/FidePolizza/${ID_Polizza}/coobbligato`}>
                        <Tooltip title={Trad.Trad("Coobbligati")}>
                            <IconButton size="small" aria-label="add">
                                <GroupIcon color="action" />
                            </IconButton>
                        </Tooltip>
                    </NavLink>
                </_PageTitle>
                <_MainContent WithPaper={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <_InfoTabs ID_Anag={ID_Anag} ID_FideAffidamento={ID_FideAffidamento} />
                        </Grid>
                        <Grid item xs={12}>
                            <_BondForm />
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/Bond.tsx